import { Viewer, Worker, RenderPageProps } from '@react-pdf-viewer/core';
import { searchPlugin } from '@react-pdf-viewer/search';
import React from 'react';
import '@react-pdf-viewer/core/lib/styles/index.css';
import '@react-pdf-viewer/search/lib/styles/index.css';

interface pdfProps {
  url: string;
  highlightRegexp?: RegExp;
}
const PdfViewer = ({ url, highlightRegexp }: pdfProps) => {
  const searchPluginInstance = searchPlugin({
    keyword: highlightRegexp,
  });

  return (
    <Worker workerUrl="https://unpkg.com/pdfjs-dist@3.4.120/build/pdf.worker.min.js">
      <Viewer
        fileUrl={url}
        renderPage={(renderPageProps) => <CustomPageLayer renderPageProps={renderPageProps} />}
        plugins={[searchPluginInstance]}
      />
    </Worker>
  );
};

export default PdfViewer;

export const CustomPageLayer: React.FC<{ renderPageProps: RenderPageProps }> = ({
  renderPageProps,
}) => {
  React.useEffect(() => {
    if (renderPageProps.textLayerRendered) {
      renderPageProps.markRendered(renderPageProps.pageIndex);
    }
  }, [renderPageProps, renderPageProps.textLayerRendered]);

  return (
    <>
      {renderPageProps.svgLayer.children}
      {renderPageProps.textLayer.children}
      {renderPageProps.annotationLayer.children}
    </>
  );
};
